// assets
import { DashboardOutlined, ExperimentOutlined, LineChartOutlined, UserOutlined, SettingOutlined, CrownOutlined, AppstoreOutlined, MedicineBoxOutlined, BookOutlined, ApiOutlined, FundOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  ExperimentOutlined,
  LineChartOutlined,
  UserOutlined,
  SettingOutlined,
  CrownOutlined,
  AppstoreOutlined,
  MedicineBoxOutlined,
  BookOutlined,
  ApiOutlined,
  FundOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: '',
  type: 'group',
  children: [
    {
      id: 'reef-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/reef-dashboard',
      icon: icons.FundOutlined,
      breadcrumbs: false
    },
    {
      id: 'trends',
      title: 'Parameters',
      type: 'item',
      url: '/trends',
      icon: icons.LineChartOutlined,
      breadcrumbs: false
    },
    {
      id: 'journal',
      title: 'Tank log',
      type: 'item',
      url: '/journal',
      icon: icons.BookOutlined,
      breadcrumbs: false
    },
    {
      id: 'tanks',
      title: 'Tanks',
      type: 'item',
      url: '/tanks',
      icon: icons.AppstoreOutlined,
      breadcrumbs: false
    },
    {
      id: 'salifert-tests',
      title: 'Test parameters',
      type: 'item',
      url: '/salifert-tests',
      icon: icons.ExperimentOutlined,
      breadcrumbs: false
    },
    {
      id: 'dosing',
      title: 'Dosing',
      type: 'item',
      url: '/dosing',
      icon: icons.MedicineBoxOutlined,
      breadcrumbs: false
    },
    {
      id: 'devices',
      title: 'Devices',
      type: 'item',
      url: '/devices',
      icon: icons.ApiOutlined,
      breadcrumbs: false
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false
    },
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-users',
      title: 'User management',
      type: 'item',
      url: '/admin/users',
      icon: icons.UserOutlined,
      breadcrumbs: false
    },
    {
      id: 'get-subscription',
      title: 'Get subscription',
      type: 'item',
      url: '/get-subscription',
      icon: icons.CrownOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
